<div class="page-logo">
  <img src="assets/img/{{logo}}" alt="{{appFlavor}}" aria-roledescription="logo">
  <span class="page-logo-text mr-1">{{appFlavor}}</span>
  <span
    class="position-absolute text-white opacity-50 small pos-top pos-right mr-2 mt-n2">{{appFlavorSubscript}}</span>

</div>
